import { HomeWrapper } from "./HomeStyles";

import mccc from "../../assets/images/micheal header.webp";
import cert from "../../assets/images/cert.webp";
import cert2 from "../../assets/images/cert2.webp";
import cert3 from "../../assets/images/cert3.webp";
import About from "../../Components/About/About";
import Offer from "../../Components/Offer/Offer";
import BlogSlider from "../../Components/BlogSlider/BlogSlider";
import ClientAndPartners from "../../Components/ClientAndPartners/Client";

const Home = () => {
  return (
    <HomeWrapper>
      <div className="top">
        <div className="first-child">
          <h1>
            Denukan Network
            <br /> Limited.
          </h1>
          <h3>NDPR , ISO 9001, ISO 27001 , PCIDSS</h3>
          <h2>Integrating tech-centered solutions into everyday life.</h2>
        </div>
        <div className="imgWrapper">
          <img src={mccc} alt="illustration for core tech" />
        </div>
      </div>
      <About />
      <ClientAndPartners />
      <Offer />
      <section className="certifications-awards">
        <h2>Certifications & Awards</h2>
        <p>
          A quick look at some of our certifications and recognitions that
          reinforce our commitment to quality, security, and service delivery.
        </p>
        <div className="certifications-grid">
          <div className="certificate-card">
            <div className="certificate-media">
              <img src={cert} alt="PCID certification document" />
            </div>
            <div className="certificate-content">
              <h3>PCIDSS</h3>
              <p>
                Payment card industry compliance focused on secure data handling
                and transaction protection.
              </p>
            </div>
          </div>
          <div className="certificate-card">
            <div className="certificate-media">
              <img src={cert2} alt="ISO 9001 certification document" />
            </div>
            <div className="certificate-content">
              <h3>ISO 27001</h3>
              <p>
                Information security management certification that reinforces confidentiality, integrity, and availability controls
              </p>
            </div>
          </div>
          <div className="certificate-card">
            <div className="certificate-media">
              <img src={cert3} alt="ISO 27001 certification document" />
            </div>
            <div className="certificate-content">
              <h3>ISO 9001</h3>
              <p>
                Quality management certification showing consistent, reliable,
                and customer-focused operational standards.
              </p>
            </div>
          </div>
        </div>
      </section>
      <br />
      <br />
      <BlogSlider />
      <br />
    </HomeWrapper>
  );
};

export default Home;
